<template>
  <div class="hour-headers calendar-row-header">
    <div
      v-for="hourHeader in hourHeaders"
      class="hour-block"
    >
      <span class="hour">{{ hourHeader }}</span>
      <div
        v-for="quarter in 4"
        class="quarter-block"
      />
    </div>
  </div>
</template>

<script>
import { getHours } from "../../../utils/date-helper.js";
import dateFns from "date-fns";
import koLocale from "date-fns/locale/ko";

export default {
	name: "ScheduleCalendarTimeline",
	data() {
		return {
			hours: getHours(0, 23),
		};
	},
	computed: {
		hourHeaders() {
			return this.hours.map(hour =>
				dateFns.format(hour, "A h시", { locale: koLocale })
			);
		},
	},
};
</script>

<style lang="scss">
.hour-headers {
	.hour-block {
		position: relative;

		.quarter-block {
			height: 14px;
			border-bottom: solid 1px rgba(255, 255, 255, 0);
		}

		.hour {
			position: absolute;
			top: -11px;
			right: 8px;
			font-size: 13px;
			letter-spacing: -0.8px;
			text-align: right;
			color: #4a4a4a;
		}

		&:first-child {
			.hour {
				display: none;
			}
		}

		.quarter-block:last-child {
			border-bottom: solid 2px rgba(255, 255, 255, 0);
		}

		@media screen and (max-width: 768px) {
			.hour {
				font-size: 11px;
			}
		}
	}
}
</style>
